import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import router from 'vue-router'

const state = {
    accept_cookies: false,
    policy_modal: false,
    policy_preferences_modal: false,
}

const actions = {
    SET_POLICY(context, [value]) {
        context.commit('SAVE_POLICY', [value])
    },
    SET_POLICY_PREFERENCES(context, [value]) {
        context.commit('SAVE_POLICY_PREFERENCES', [value])
    },
    SET_COOKIES(context, [value]) {
        context.commit('SAVE_COOKIES', [value])
    },
    SET_OPTIONAL_COOKIES(context, [value]) {
        context.commit('SAVE_OPTIONAL_COOKIES', [value])
    },
}

const mutations = {
    SAVE_POLICY: (state, [value]) => {
        Vue.set(state, 'policy_modal', value)
    },

    SAVE_POLICY_PREFERENCES: (state, [value]) => {
        Vue.set(state, 'policy_preferences_modal', value)
    },

    SAVE_COOKIES: (state, [value]) => {
        Vue.set(state, 'accept_cookies', value)

        let ids = []
        ids.push('UA-53707923-3')

        if (process.env.ID_GOOGLE_ANALYTICS != '') ids.push(process.env.ID_GOOGLE_ANALYTICS)
        if (process.env.ID_GOOGLE_ANALYTICS_CLIENT != '') ids.push(process.env.ID_GOOGLE_ANALYTICS_CLIENT)
        Vue.use(VueAnalytics, {
            id: ids,
            checkDuplicatedScript: true,
            router,
        })
    },

    SAVE_OPTIONAL_COOKIES: (state, [value]) => {
        Vue.set(state, 'accept_cookies', value)
    },
}

const getters = {
    accept_cookies: state => {
        return state.accept_cookies
    },

    policy_modal: state => {
        return state.policy_modal
    },

    policy_preferences_modal: state => {
        return state.policy_preferences_modal
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}